import { Component, OnInit } from '@angular/core';
import { LocationService } from 'src/app/_services/location.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  innerHeight: any;
  country: any;
  lang: any;

  constructor(private locationService: LocationService) {
    this.innerHeight = (window.screen.height-280) + "px" ;
    
   }

  ngOnInit() {
    this.country = this.locationService.country;
    this.lang = this.locationService.langCode;
  }

}
